import Vue from 'vue'

export default {
  name: 'JbfTable',
  props: {
    // el-table 相关属性
    columns: {
      required: true,
      type: Array,
    },
    data: {
      type: Array,
      default: function () {
        return [];
      }
    },
    border: {
      type: Boolean,
      default: true,
    },
    height: [String, Number],
    maxHeight: [String, Number],
    highlightCurrentRow: Boolean,
    currentRowKey: [String, Number],
    showSummary: Boolean,
    showHeader: {
      type: Boolean,
      default: true
    },
    // el-pagination 相关属性
    showPage: {
      type: Boolean,
      default: true
    },
    pageSizes: {
      type: Array,
      default() {
        return [100, 200, 400];
      }
    },
    pageSize: {
      type: Number,
      default: 100,
    },
    total: Number,
    currentPage: {
      type: Number,
      default: 1
    },
    pageSmall: Boolean,
    pageLayout: {
      default: "total, sizes, prev, pager, next"
    },
    hideOnSinglePage: Boolean,
  },
  data() {
    return {
      columnsInner: [],
    }
  },
  computed: {
    flexColumns() {
      return this.columnsInner.filter(item => typeof (item.show) !== 'undefined')
    },
    showColumns() {
      return this.columnsInner.filter(item => typeof (item.show) === 'undefined' || item.show)
    },
  },
  watch: {
    columns: {
      handler(val) {
        this.columnsInner = [];
        val.forEach(item => {
          this.columnsInner.push(item);
        });
      },
      immediate: true,
    }
  },
  methods: {
    setCurrentRow(row){
      this.$refs.elTable.setCurrentRow(row);
    },
    handleCellClick(row, column, cell, event) {
      this.$emit("cell-click", row, column, cell, event);
    },
    handleRowClick(row, column, cell, event) {
      this.$emit("row-click", row, column, cell, event);
    },
    handleSortChange(val) {
      this.$emit("sort-change", val);
    },
    handleSelectionChange(selection) {
      this.$emit("selection-change", selection);
    },
    handleCurrentChange(val) {
      this.$emit("current-change", val);
    },
    handleFilterChange(val) {
      this.$emit("filter-change", val);
    },
    handleSizeChange(val) {
      this.$emit("update:pageSize", val);
      this.$emit("size-change", val);
    },
    handleCurrentPageChange(val) {
      this.$emit("update:currentPage", val);
      this.$emit("page-change", val);
    },
  },
  render(createElement) {
    return createElement('div', {
      class: ['clearfix'],
      style: {position: 'relative'},
    }, ['el-popover', 'el-table', 'batch-options', 'el-pagination'].map(el => {
      // el-popover 筛选列
      if (el === 'el-popover' && this.flexColumns.length > 0) {
        return createElement('el-popover', {props: {'trigger': 'hover'}}, [
          createElement('div', this.flexColumns.map(column => {
            // 候选列
            return createElement('el-checkbox', {
              style: {
                'padding-top': '6px',
                display: 'block',
              },
              props: {value: column.show},
              key: column.prop,
              on: {
                input(val) {
                  Vue.prototype.$set(column, 'show', val);
                  // column.show = val;
                }
              }
            }, column.label)
          })),
          // 筛选列触发按钮
          createElement('el-button', {
            style: {
              position: 'absolute',
              right: '8px',
              'z-index': '2',
              padding: '15px 0',
            },
            props: {size: "medium", type: "text", icon: "el-icon-s-operation"},
            slot: "reference"
          }),
        ])
      }
      // el-table
      if (el === 'el-table') {
        return createElement('el-table', {
          ref:'elTable',
          props: {...this.$props},
          on: {
            'cell-click': this.handleCellClick,
            'row-click': this.handleRowClick,
            'sort-change': this.handleSortChange,
            'selection-change': this.handleSelectionChange,
            'current-change': this.handleCurrentChange,
            'filter-change': this.handleFilterChange
          },
        }, this.showColumns.map(column => {
          let children = [];
          let slot;
          // el-table-column default slot
          if (column.prop) {
            slot = this.$scopedSlots[column.prop];
            if (!slot) {
              slot = this.$slots[column.prop];
            }
            if (slot) {
              children.push(slot)
            }
          }
          // el-table-column header slot
          let scopedSlots = {};
          if (column.header) {
            slot = this.$scopedSlots[column.header];
            if (!slot) {
              slot = this.$slots[column.header];
            }
            if (slot) {
              // 在数据对象中传递 `scopedSlots`
              // 格式为 { name: props => VNode | Array<VNode> }
              scopedSlots.header = props => slot(props);
            }
          }
          // el-table-column
          return createElement('el-table-column', {
            props: column,
            key: column.prop,
            scopedSlots: scopedSlots,
          }, children)
        }))
      }
      if (el === 'batch-options') {
        return this.$slots.batchOptions;
      }
      // el-pagination
      if (el === 'el-pagination' && this.showPage) {
        return createElement('el-pagination', {
          class: ['pagination'],
          props: {
            small: this.pageSmall,
            'page-sizes': this.pageSizes,
            'page-size': this.pageSize,
            total: this.total,
            'current-page': this.currentPage,
            layout: this.pageSmall ? "total,sizes,  prev, pager, next" : "total, sizes, prev, pager, next",
            hideOnSinglePage: this.hideOnSinglePage,
          },
          on: {
            'size-change': this.handleSizeChange,
            'current-change': this.handleCurrentPageChange,
          },
        })
      }
    }));
  }
}
